import axios from "axios";
import { msalInstance, tokenRequest } from "../config/authConfig";
import { store } from "../store/store";
import { logout } from "../redux/authSlice";

export const ACCEPT_TYPES = {
  binary: "application/octet-stream",
} as const;

//  Create an Axios instance
const apiClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL, // Your backend API URL
  headers: { "Content-Type": "application/json" },
});

//  Function to get the access token from MSAL
const getToken = async () => {
  const accounts = msalInstance.getAllAccounts();
  if (accounts.length === 0) return null; // No logged-in user

  try {
    const response = await msalInstance.acquireTokenSilent({
      ...tokenRequest,
      account: accounts[0],
    });
    return `Bearer ${response.accessToken}`;
  } catch (error) {
    console.error("Token retrieval failed:", error);
    return null;
  }
};

//  Request Interceptor - Attach Token
apiClient.interceptors.request.use(
  async (config) => {
    const token = await getToken();
    if (token) {
      config.headers.Authorization = token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

//  Response Interceptor - Handle Token Expiry (401)
apiClient.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response?.status === 401) {
      console.warn("401 Unauthorized - Attempting token refresh...");

      try {
        const refreshSuccess = await getToken();
        if (refreshSuccess) {
          console.log(" Token refreshed successfully. Retrying request...");
          error.config.headers.Authorization = refreshSuccess;
          return apiClient(error.config); // Retry failed request
        }
      } catch (refreshError) {
        console.error("Refresh token failed. Logging out...");
        store.dispatch(logout()); // Dispatch Redux logout action
      }
    }
    return Promise.reject(error);
  },
);

export default apiClient;
